import { render, staticRenderFns } from "./OpenOrdersOverview.vue?vue&type=template&id=3af64d88"
import script from "./OpenOrdersOverview.vue?vue&type=script&lang=js"
export * from "./OpenOrdersOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports